import { render, staticRenderFns } from "./bus.vue?vue&type=template&id=29684f4e"
import script from "./bus.vue?vue&type=script&lang=js"
export * from "./bus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports